import React from 'react';

type MatchType = 'PERFECT_PUBLISH' | 'FALSE_POSITIVE' | 'MISSED_OPPORTUNITY' | 'SAFELY_CAUGHT';

interface MatchTypeBadgeProps {
  matchType: MatchType | string | null | undefined;
  fallbackText?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

export const MatchTypeBadge = ({ 
  matchType, 
  fallbackText = 'unknown',
  size = 'sm' 
}: MatchTypeBadgeProps) => {
  const getBadgeClass = (type: MatchType | string | null | undefined): string => {
    const baseClass = `badge badge-${size}`;
    
    switch (type as MatchType) {
      case 'PERFECT_PUBLISH':
        return `${baseClass} badge-success`;
      case 'FALSE_POSITIVE':
        return `${baseClass} badge-error`;
      case 'MISSED_OPPORTUNITY':
        return `${baseClass} badge-warning`;
      case 'SAFELY_CAUGHT':
        return `${baseClass} badge-info`;
      default:
        return `${baseClass} badge-neutral`;
    }
  };

  const getDisplayText = (type: MatchType | string | null | undefined): string => {
    return type ?? fallbackText;
  };

  return (
    <span className={getBadgeClass(matchType)}>
      {getDisplayText(matchType)}
    </span>
  );
};
